import React from "react"
import { Route, Routes } from "react-router-dom"
import ScoringSessionLogin from "../pages/ScoringSessionLogin.tsx"
import Scoring from "../pages/Scoring.tsx"
import Voting from "../pages/Voting.tsx"
import VotingSessionLogin from "../pages/VotingSessionLogin.tsx"
import LandingPage from '../pages/LandingPage.tsx'
import FacilitatorLogin from "../pages/FacilitatorLogin.tsx"
import FacilitatorPage from "../pages/FacilitatorPage.tsx"

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/ScoringSession" element={<ScoringSessionLogin/>}></Route>
            <Route path="/VotingSession" element={<VotingSessionLogin/>}></Route>
            <Route path="/Login" element={<FacilitatorLogin/>}></Route>
            <Route path="/FacilitatorPage" element={<FacilitatorPage/>}></Route>
            <Route path="/LandingPage" element={<LandingPage/>}></Route>
            <Route path="/Scoring" element={<Scoring/>}></Route>
            <Route path="/Voting" element={<Voting/>}></Route>
        </Routes>
    )
}

export default AppRoutes;